import React, { useState } from "react"
import styled, { keyframes } from "styled-components"
import { VscZoomIn, VscClose } from "react-icons/vsc"
import Loader from "react-loader-spinner";
import { Carousel } from "react-responsive-carousel"
import Modal from "react-responsive-modal"
import customAnimationStyles from "../styles/modal-carousel.module.css"

const initialAnimation = keyframes`
    0%{
        opacity: 0;
    }

    100%{
        opacity: 1;
    }
`

const Project = styled.div`
  width: 100%;
  height: 250px;
  text-align: center;
  position: relative;
  background-image: url(${props => props.img});
  border-radius: 2px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  border: 1px solid transparent;
  cursor: zoom-in;
  transition: all 0.4s;

  &:hover {
  }
`

const CardProject = ({ img, name, dev, link, carrosselImg, key }) => {
  const [open, setOpen] = useState(false)
  const onOpenModal = () => {
    setOpen(true)
  }

  const onCloseModal = () => {
    setOpen(false)
  }

  return (
    <Project img={require(`../images/${img}`)} key={key}>
      <Mask onClick={() => setOpen(true)}></Mask>
      
        {dev ? <NameDev> <a>In Development <Loader
        type="Triangle"
        className="spinner"
        color="var(--color-primary)"
        height={20}
        width={20}
        timeout={0} //3 secs
      /></a> </NameDev>:  <Name><a>{name}</a></Name>}
      
      <Modal
        open={open}
        onClose={onCloseModal}
        center
        blockScroll={false}
        animationDuration={400}
        classNames={{
          overlay: customAnimationStyles.customOverlay,
          modal: customAnimationStyles.customModal,
          closeButton: customAnimationStyles.customCloseButton,
          closeIcon: customAnimationStyles.customCloseIcon,
          transitionEnter: customAnimationStyles.transitionEnter,
          animationIn: "customEnterAnimation",
          animationOut: "customLeaveAnimation",
          transitionEnterActive: customAnimationStyles.transitionEnterActive,
          transitionExit: customAnimationStyles.transitionExitActive,
          transitionExitActive: customAnimationStyles.transitionExitActive,
        }}
      >
        <HeaderCarousel>
          {dev ? <Loader
          type="Triangle"
          className="spinner"
          color="var(--color-primary)"
          height={35}
          width={35}
          timeout={0} //3 secs
        />:  <h1>{name}</h1>}
          <VscClose onClick={onCloseModal} className="close" />
        </HeaderCarousel>
        <Carousel
          className="carousel-style"
          showThumbs={false}
          showStatus={false}
        >
          {carrosselImg.map((imagem, i) => (
            <div className="slider-item-div" key={imagem}>
              <img alt="" src={require(`../images/${imagem}`)} />
            </div>
          ))}
        </Carousel>
      </Modal>
    </Project>
  )
}

const Mask = styled.div`
  height: 100%;
  transition: all 0.4s;
  background-color: #29292930;

  &:hover {
   background-color: transparent;
  }
`

const Name = styled.div`
  position: absolute;
  left: 6%;
  bottom: 8%;
  background-color: #181818cc;
  border-radius: 2px;
  transition: all 0.4s;

  a {
    font-weight: 400;
    color: white;
    font-size: 15px;
    display: block;
    padding: 0.2rem 0.8rem;
    letter-spacing: 1px;
    cursor: pointer;
    text-decoration: none;
    border: 1px solid transparent;
    transition: all 0.4s;

    &::after {
      content: "";
      display: block;
      width: 0%;
      height: 1px;
      background-color: var(--color-primary);
      transition: all 0.4s ease-out;
    }
  }

  .disable {
    &:hover {
      color: var(--color-white-1);
      cursor: text;
    }
  }

  &:hover {
    background-color: #181818;
    a {
      color: white;

      &::after {
        width: 100%;
      }
    }
    .link {
    }
  }

  .link {
    font-size: 0.9rem;
    margin-left: 0.2rem;
    color: var(--color-grey-1);
    transition: all 0.2s;
  }
`

const NameDev = styled.div`
  position: absolute;
  left: 6%;
  bottom: 8%;
  background-color: #181818;
  border-radius: 2px;
  padding: 0.2rem 0.8rem;
  display: flex;
  align-items: center;
  transition: all 0.4s;


  a {
    font-weight: 400;
    color: white;
    display: flex;
    font-size: 15px;
    align-items: center;
    letter-spacing: 1px;
    cursor: pointer;
    text-decoration: none;
    border: 1px solid transparent;
    transition: all 0.4s;

  }
    .spinner{
      margin: 0;
      margin-left: .8rem;
      padding-top: .2rem;
    }


  .disable {
    &:hover {
      color: var(--color-white-1);
      cursor: text;
    }
  }

  &:hover {
    background-color: #181818;
    a {
      color: white;

      &::after {
        width: 100%;
      }
    }
    .link {
    }
  }


`

const HeaderCarousel = styled.div`
  background-color: #181818cc;
  position: absolute;
  width: 100%;
  z-index: 70;
  padding: 0.5rem 0rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: all 0.2s ease-out;
  h1 {
    margin-left: 1.5rem;
    font-size: 1.5rem;
    display: flex;
    align-items: center;
    font-weight: 400;
    color: var(--color-white-1);
  }

  .spinner{
      margin: 0 1rem;
      padding-top: .2rem;
    }
    
  .close {
    margin-right: 1.5rem;
    font-size: 2rem;
    color: var(--color-white-2);
    cursor: pointer;
    transition: all 0.4s;
    &:hover {
      color: var(--color-white-1);
    }
  }

  &:hover {
    background-color: #181818;
  }
`
export default CardProject
